// extracted by mini-css-extract-plugin
export default {"msg":"GlobalMessage_msg__Hbuj1","success":"GlobalMessage_success__gxIIn","error":"GlobalMessage_error__D3FSj"};